/** @jsx jsx */
import { jsx, Box } from 'theme-ui';
import { FunctionComponent } from 'react';
import { FluidImage as ImageType } from '@codersclan/gatsby-theme-airfleet/src/@types';
import styled from '@emotion/styled';

import format from 'date-fns/format';

// Components
import Text, { TEXT_TYPES } from '../text';
import Avatar from '../avatar';

// Styles
import * as style from './style';
import { Link } from 'gatsby';

interface PostHeaderProps {
  title: string;
  date: Date;
  author: {
    image?: ImageType;
    name: string;
    headline: string;
    slug?: string;
  };
}

const PostHeader: FunctionComponent<PostHeaderProps> = ({
  title,
  date,
  author,
}) => (
  <Box sx={style.Container}>
    <Text type={TEXT_TYPES.H1_BOLD} sx={style.PostTitle}>
      {title}
    </Text>
    <Text type={TEXT_TYPES.DATELINE} sx={style.PostDate}>
      {format(date, 'PP')}
    </Text>
    <Box sx={style.AuthorBox}>
      {author.image && (
        <UnstyledLink to={`/authors/${author.slug}`}>
          <Avatar size={['109px']} image={author.image} sx={style.AuthorImg} />
        </UnstyledLink>
      )}
      <UnstyledLink to={`/authors/${author.slug}`}>
        <Text type={TEXT_TYPES.AUTHOR_NAME} sx={style.AuthorName}>
          {author.name}
        </Text>
      </UnstyledLink>
      <UnstyledLink to={`/authors/${author.slug}`}>
        <Text type={TEXT_TYPES.CAPTION} sx={style.AuthorHeadline}>
          {author.headline}
        </Text>
      </UnstyledLink>
    </Box>
  </Box>
);

export default PostHeader;

const UnstyledLink = styled(Link)`
  color: currentColor;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;
